import { replace } from 'lodash';

const currencyIntegerFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const currencyDecimalFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat('en-US');
const decimalFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const oneDecimalFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
const percentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
const compactFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
});

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];

function formatFileSize(number) {
  if (!Number.isFinite(number)) {
    return '0 B';
  }

  const absNumber = Math.abs(number);
  if (absNumber < 1024) {
    return `${numberFormatter.format(number)} B`;
  }

  const unitIndex = Math.min(
    Math.floor(Math.log(absNumber) / Math.log(1024)),
    FILE_SIZE_UNITS.length - 1
  );
  const value = number / 1024 ** unitIndex;

  return `${oneDecimalFormatter.format(value)} ${FILE_SIZE_UNITS[unitIndex]}`;
}

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return Number.isInteger(number)
    ? currencyIntegerFormatter.format(number)
    : currencyDecimalFormatter.format(number);
}

export function fBytes(number) {
  return formatFileSize(number);
}

export function fPercent(number) {
  return percentFormatter.format(number / 100);
}

export function fNumber(number) {
  return numberFormatter.format(number);
}

export function fNumberDecimals(number) {
  return decimalFormatter.format(number);
}

export function fShortenNumber(number) {
  return replace(compactFormatter.format(number), '.00', '');
}

export function fData(number) {
  return formatFileSize(number);
}
